export default "__VITE_ASSET__4yq$AcYJ__"